import { createStore, applyMiddleware } from 'redux';
import thunk from "redux-thunk"
import storeReducer from './reducers';


const store = createStore(storeReducer, applyMiddleware(thunk))

export default store;